const updatesData = [
  { date: '07-31', title: '《极限追凶》今日上线', desc: '高智商犯罪动作大片正式登陆悟空影视，4K超清画质', tag: '新片上线' },
  { date: '07-30', title: '暑期档专题页面上线', desc: '精选50部暑期必看影片，涵盖动作、喜剧、科幻多题材', tag: '专题' },
  { date: '07-29', title: '播放体验全面优化', desc: '升级视频编解码技术，加载速度提升40%，观影更流畅', tag: '升级' },
  { date: '07-28', title: '《星际迷航：新纪元》热度破千万', desc: '科幻巨制上线一周即突破千万次观看', tag: '热门' },
  { date: '07-27', title: '喜剧片专题周开启', desc: '每日推荐一部高分喜剧，周末更有连播专场', tag: '活动' },
  { date: '07-26', title: '新增悬疑推理分类', desc: '收录国内外经典悬疑片，满足推理爱好者需求', tag: '更新' },
  { date: '07-25', title: '移动端适配全面完成', desc: '手机观影体验大幅提升，支持手势控制与投屏', tag: '升级' },
  { date: '07-24', title: '《暗夜行者》独家上线', desc: '暗黑风格犯罪动作片，悟空影视平台独家首播', tag: '独家' },
  { date: '07-23', title: '片库突破20000部', desc: '悟空影视电影大全持续扩增，覆盖更多题材与语种', tag: '里程碑' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-timer-line text-2xl text-primary-500"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 font-bold">
            最新动态
          </h2>
        </div>
        <p className="text-sm text-foreground-400 mb-8 md:mb-10 ml-11">
          悟空影视最新电影上线与平台动态速递
        </p>

        <div className="relative">
          <div className="absolute left-[19px] top-3 bottom-3 w-px bg-background-200/60"></div>

          <div className="flex flex-col gap-6">
            {updatesData.map((item, idx) => (
              <div key={idx} className="flex gap-5 pl-0">
                <div className="relative z-10 flex-shrink-0 w-10 h-10 rounded-full bg-background-100 border-2 border-primary-500/40 flex items-center justify-center">
                  <span className="text-[10px] text-primary-400 font-semibold leading-tight text-center">{item.date}</span>
                </div>
                <div className="flex-1 pt-1">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <h3 className="text-sm font-semibold text-foreground-200">{item.title}</h3>
                    <span className="px-2 py-0.5 text-[10px] font-medium rounded-full bg-primary-500/10 text-primary-400 border border-primary-500/20 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}